import { ArdoqId, AssetType } from '@ardoq/api-types';
import { logWarn } from '@ardoq/logging';
import { isArdoqError } from '@ardoq/common-helpers';
import { workspaceFolderApi } from './workspaceFolderApi';

type FileAssetInFolderArgs = {
  assetId: ArdoqId;
  folderId: ArdoqId;
  assetType: AssetType;
};

export const fileAssetInFolder = async ({
  assetId,
  folderId,
  assetType,
}: FileAssetInFolderArgs): Promise<void> => {
  const moveResult = await workspaceFolderApi.moveAssets({
    targetFolderId: folderId,
    content: [{ _id: assetId, type: assetType }],
  });
  if (isArdoqError(moveResult)) {
    logWarn(moveResult, `Created a ${assetType} but could not file it`, {
      fingerprint: ['file-asset-in-folder-failed'],
      assetType,
    });
  }
};
